import type { Question } from '@new_project/shared';
import { evaluateWhen } from './when';

/**
 * The answers of the questions the form shows, which are also the ones to
 * submit. Copier renders with an answer given for a question whose `when` is
 * false, and only leaves it out of `.copier-answers.yml`, so a hidden
 * `deploy=true` would render the deploy chain without recording it.
 *
 * Walked in copier.yml order, each `when` against the answers kept so far, as
 * Copier asks them: a question that depends on a hidden answer is hidden too
 * (`prod_target` behind a `deploy` hidden by its own `when`). A `when` we cannot
 * parse counts as visible.
 */
export function visibleAnswers(
  questions: Question[],
  answers: Record<string, unknown>,
): Record<string, unknown> {
  const submitted = { ...answers };
  for (const q of questions) {
    if (!evaluateWhen(q.when, submitted)) delete submitted[q.name];
  }
  return submitted;
}
